import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBrightnessMediumComponent } from "./med-icon-brightness-medium.component";

@NgModule({
  declarations: [
    MedIconBrightnessMediumComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBrightnessMediumComponent,
  ],
})
export class MedIconBrightnessMediumModule { }
